import { render, staticRenderFns } from "./DtuStatus.vue?vue&type=template&id=12f09404&"
import script from "./DtuStatus.vue?vue&type=script&lang=js&"
export * from "./DtuStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports